export default __webpack_public_path__ + "static/media/8k_earth_daymap.54672c1f.jpeg";